import React from 'react';
import MockInterviewHome from '../../components/MockInterview/MockInterviewHome';

const TenantMockInterviewHome = () => {
  return <MockInterviewHome mode="tenant" />;
};

export default TenantMockInterviewHome;
